// @flow
import createIcon from './utils/createIcon'

export default createIcon({
  iconName: 'star',
  icon: [
    16,
    16,
    null,
    null,
    'M8 11.121L4.292 13 5 9.02 2 6.202l4.146-.581L8 2l1.854 3.621 4.146.58-3 2.82.708 3.979z',
  ],
})
